
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'V2QuantityStepper',
  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 999
    },
    label: {
      type: String,
      default: 'Quantity'
    }
  },
  methods: {
    clamp(val: number): number {
      return Math.min(Math.max(val, this.min), this.max)
    },
    increment() {
      this.$emit('input', this.clamp(this.value + 1))
    },
    decrement() {
      this.$emit('input', this.clamp(this.value - 1))
    },
    onBlur(e: Event) {
      const val = Number((e.target as HTMLInputElement).value)
      this.$emit('input', this.clamp(isFinite(val) ? val : this.min))
    }
  }
})
